import { render, staticRenderFns } from "./ScopingSingleAssessment.vue?vue&type=template&id=44176d0c&scoped=true&"
import script from "./ScopingSingleAssessment.vue?vue&type=script&lang=js&"
export * from "./ScopingSingleAssessment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44176d0c",
  null
  
)

export default component.exports